// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cmdk-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  backdrop-filter: blur(3px);
  z-index: var(--z-command, 1080);
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 12vh;
  animation: fadeIn var(--transition-fast);
}

.cmdk {
  width: min(640px, 92vw);
  max-height: 70vh;
  display: flex;
  flex-direction: column;
  background: var(--color-dark-lighter);
  border: 1px solid var(--glass-border-strong);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-xl);
  overflow: hidden;
}

.cmdk-input {
  padding: var(--space-md) var(--space-lg);
  border: none;
  border-bottom: 1px solid var(--glass-border);
  background: transparent;
  color: var(--color-white);
  font-size: var(--font-size-lg);
  font-family: var(--font-family);
  outline: none;
}

.cmdk-input::placeholder {
  color: var(--color-white);
  opacity: 0.5;
}

.cmdk-list {
  list-style: none;
  margin: 0;
  padding: var(--space-xs);
  overflow-y: auto;
}

.cmdk-empty {
  padding: var(--space-lg);
  text-align: center;
  opacity: 0.6;
  color: var(--color-white);
}

.cmdk-item {
  display: flex;
  align-items: center;
  gap: var(--space-md);
  width: 100%;
  padding: var(--space-sm) var(--space-md);
  background: transparent;
  border: none;
  border-radius: var(--radius-md);
  color: var(--color-white);
  font-size: var(--font-size-sm);
  cursor: pointer;
  text-align: left;
}

.cmdk-item-active {
  background: var(--gradient-primary);
}

.cmdk-item-icon {
  width: 1.4em;
  text-align: center;
  flex-shrink: 0;
}

.cmdk-item-label {
  flex: 1 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.cmdk-item-kind {
  font-size: var(--font-size-xs);
  opacity: 0.5;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  flex-shrink: 0;
}

.cmdk-footer {
  display: flex;
  gap: var(--space-md);
  padding: var(--space-sm) var(--space-md);
  border-top: 1px solid var(--glass-border);
  font-size: var(--font-size-xs);
  opacity: 0.7;
  color: var(--color-white);
}

.cmdk-footer kbd {
  background: var(--glass-bg);
  border: 1px solid var(--glass-border);
  border-radius: 4px;
  padding: 1px 5px;
  margin-right: 2px;
  font-family: inherit;
}
`, "",{"version":3,"sources":["webpack://./src/components/CommandPalette.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,0BAA0B;EAC1B,+BAA+B;EAC/B,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,iBAAiB;EACjB,wCAAwC;AAC1C;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,qCAAqC;EACrC,4CAA4C;EAC5C,+BAA+B;EAC/B,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;EACxC,YAAY;EACZ,4CAA4C;EAC5C,uBAAuB;EACvB,yBAAyB;EACzB,8BAA8B;EAC9B,+BAA+B;EAC/B,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,WAAW;EACX,wCAAwC;EACxC,uBAAuB;EACvB,YAAY;EACZ,+BAA+B;EAC/B,yBAAyB;EACzB,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;EAC9B,YAAY;EACZ,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,wCAAwC;EACxC,yCAAyC;EACzC,8BAA8B;EAC9B,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB","sourcesContent":[".cmdk-backdrop {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.55);\n  backdrop-filter: blur(3px);\n  z-index: var(--z-command, 1080);\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  padding-top: 12vh;\n  animation: fadeIn var(--transition-fast);\n}\n\n.cmdk {\n  width: min(640px, 92vw);\n  max-height: 70vh;\n  display: flex;\n  flex-direction: column;\n  background: var(--color-dark-lighter);\n  border: 1px solid var(--glass-border-strong);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-xl);\n  overflow: hidden;\n}\n\n.cmdk-input {\n  padding: var(--space-md) var(--space-lg);\n  border: none;\n  border-bottom: 1px solid var(--glass-border);\n  background: transparent;\n  color: var(--color-white);\n  font-size: var(--font-size-lg);\n  font-family: var(--font-family);\n  outline: none;\n}\n\n.cmdk-input::placeholder {\n  color: var(--color-white);\n  opacity: 0.5;\n}\n\n.cmdk-list {\n  list-style: none;\n  margin: 0;\n  padding: var(--space-xs);\n  overflow-y: auto;\n}\n\n.cmdk-empty {\n  padding: var(--space-lg);\n  text-align: center;\n  opacity: 0.6;\n  color: var(--color-white);\n}\n\n.cmdk-item {\n  display: flex;\n  align-items: center;\n  gap: var(--space-md);\n  width: 100%;\n  padding: var(--space-sm) var(--space-md);\n  background: transparent;\n  border: none;\n  border-radius: var(--radius-md);\n  color: var(--color-white);\n  font-size: var(--font-size-sm);\n  cursor: pointer;\n  text-align: left;\n}\n\n.cmdk-item-active {\n  background: var(--gradient-primary);\n}\n\n.cmdk-item-icon {\n  width: 1.4em;\n  text-align: center;\n  flex-shrink: 0;\n}\n\n.cmdk-item-label {\n  flex: 1;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.cmdk-item-kind {\n  font-size: var(--font-size-xs);\n  opacity: 0.5;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  flex-shrink: 0;\n}\n\n.cmdk-footer {\n  display: flex;\n  gap: var(--space-md);\n  padding: var(--space-sm) var(--space-md);\n  border-top: 1px solid var(--glass-border);\n  font-size: var(--font-size-xs);\n  opacity: 0.7;\n  color: var(--color-white);\n}\n\n.cmdk-footer kbd {\n  background: var(--glass-bg);\n  border: 1px solid var(--glass-border);\n  border-radius: 4px;\n  padding: 1px 5px;\n  margin-right: 2px;\n  font-family: inherit;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
